import { z } from 'zod'

export const RaiffeisenBankCredentialsFormSchema = z.object({
  certificate: z.string().min(1, {
    message: 'raiffeisen.form.certificate.required',
  }),
  password: z.string().min(1, {
    message: 'raiffeisen.form.password.required',
  }),
})
